import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { connectState } from '@examdojo/angular/util';
import { SelectableTreeCellComponent, SelectableTreeCellRendererBaseComponent } from '@examdojo/core/tree';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@UntilDestroy()
@Component({
  selector: 'dojo-question-bank-topics-tree-cell-renderer',
  standalone: true,
  imports: [MatCheckboxModule, SelectableTreeCellComponent],
  template: `
    @if (state.node) {
      <dojo-selectable-tree-cell
        [node]="state.node"
        [expanded]="state.expanded"
        [selected]="state.selected"
        [indeterminate]="state.indeterminate"
        [nestingLevel]="state.nestingLevel"
        [isGroup]="state.isGroup"
        (checkboxChange)="onCheckboxChange($event)"
        class="question-bank-tree-row"
      >
        @if (!state.isGroup) {
          <span class="text-disabled text-sm font-semibold md:text-xs">
            {{ state.node.originalData?.code }}
          </span>
        }
        <span extra-content class="adjusted-numbers text-disabled text-md ml-auto md:text-xs">
          {{ state.node.metadata?.count }}
        </span>
      </dojo-selectable-tree-cell>
    }
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .question-bank-tree-row {
        ::ng-deep .node-padding {
          margin-right: 15px;
        }

        ::ng-deep .tree-cell-name {
          @apply text-md md:text-sm #{!important};
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionBankTopicsTreeCellRendererComponent
  extends SelectableTreeCellRendererBaseComponent<{ code: string; sort_order: number }, { count?: number }>
  implements ICellRendererAngularComp
{
  readonly state = connectState({
    node: this.node$,
    expanded: this.isExpanded$$,
    selected: this.isSelected$$,
    indeterminate: this.isIndeterminate$$,
    nestingLevel: this.nestingLevel$,
    isGroup: this.isGroup$,
  });
}
